import { cn } from '@rematter/ui-web/lib';

import { ItemDetailRecord } from '../../../types/inventoryItem';

import { ItemFormFields } from './ItemFormFields';

type Props = {
  item?: ItemDetailRecord | null;
  disabled?: boolean;
  className?: string;
};

export const ItemDetailsForm = ({
  item,
  disabled = false,
  className,
}: Props) => (
  <div className={cn('@ItemDetailsForm', className)}>
    <ItemFormFields
      disabled={disabled}
      showTimestamps
      showAttributes
      item={item}
    />
  </div>
);
